// Small "PRO" badge shown next to gated features for free users.
// Encourages upgrade without hiding functionality outright.
export default function ProBadge({ className = "" }) {
  return (
    <span
      data-testid="pro-badge"
      className={`ml-auto inline-flex items-center px-1.5 py-0.5 text-[9px] font-mono font-bold uppercase tracking-widest bg-intl text-white rounded-sm ${className}`}
    >
      PRO
    </span>
  );
}
